import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Checkbox, SnoozeBadgeOutline, palette } from "@conserveit/blocks";
import Menu from "../../components/Menu";
import segment from "../../utils/segment";
import { $MenuTitle } from "../../components/Menu/Menu.styles";
import {
  $Wrapper,
  $IconBubble,
  $Label,
  $List,
  $Setting,
} from "./ToggleSnoozed.styles";
import { toggleShowSnoozed } from "../../redux/modules/insights/actionCreators";

function toggleShowSnoozeTracked(cb, showSnoozed) {
  return () => {
    segment.track(`Snooze switched ${showSnoozed ? "off" : "on"}`);
    cb();
  };
}

function toggleMenuTracked(isOpen) {
  segment.track(`Snooze popover ${isOpen ? "opened" : "closed"}`);
}

function mapStateToProps(state) {
  return {
    showSnoozed: state.insights.showSnoozed,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    toggleSnoozed: () => dispatch(toggleShowSnoozed()),
  };
}

const ToggleSnoozed = ({ className, toggleSnoozed, showSnoozed, count }) => (
  <Menu onToggle={toggleMenuTracked}>
    {({ isOpen, menuRef, toggle }) => (
      <$Wrapper className={className} ref={menuRef} data-cy="ToggleSnoozed">
        <$Label onClick={toggle} data-cy="ToggleSnoozed-button">
          <$IconBubble count={count}>{count}</$IconBubble>
          {count > 0 && <SnoozeBadgeOutline fillColor={palette.neutral9} />}
        </$Label>
        <$List isOpen={isOpen}>
          <$MenuTitle>SNOOZED ITEMS ({count})</$MenuTitle>
          <$Setting type="button">
            <Checkbox
              checked={showSnoozed}
              label="Show snoozed"
              onChange={toggleShowSnoozeTracked(toggleSnoozed, showSnoozed)}
            />
          </$Setting>
        </$List>
      </$Wrapper>
    )}
  </Menu>
);

ToggleSnoozed.propTypes = {
  className: PropTypes.string,
  toggleSnoozed: PropTypes.func,
  showSnoozed: PropTypes.bool,
  count: PropTypes.number,
};

ToggleSnoozed.defaultProps = {
  className: "",
  count: 0,
};

export default connect(mapStateToProps, mapDispatchToProps)(ToggleSnoozed);
